/**
 * 区分 formSubmissionStatus（form_submissions.form_submission_status）
 * 出典：要件書 5.2。2026-10-07 の決定で旧PCRM（frontend/src/utils/statusConfig.ts の SubmissionStatus）と同じ 5 値にした
 */
export const FORM_SUBMISSION_STATUS_VALUES = ['new', 'unhandled', 'in_progress', 'completed', 'spam'] as const;

export type FormSubmissionStatus = (typeof FORM_SUBMISSION_STATUS_VALUES)[number];

export const FORM_SUBMISSION_STATUS_LABELS: Readonly<Record<FormSubmissionStatus, string>> = {
  new: '新規',
  unhandled: '未対応',
  in_progress: '対応中',
  completed: '完了',
  spam: 'スパム',
};

/** 旧PCRM のバッジ色（statusConfig.ts の SUBMISSION_STATUS_CONFIG と同じ） */
export const FORM_SUBMISSION_STATUS_COLORS: Readonly<Record<FormSubmissionStatus, string>> = {
  new: '#3b82f6',
  unhandled: '#f59e0b',
  in_progress: '#8b5cf6',
  completed: '#10b981',
  spam: '#ef4444',
};

/**
 * 5 値化（2026-10-07）より前の値。ndev 等に残っているデータを一覧から落とさないために、
 * 状態を絞らない一覧では索引をこれらでも引く（変換：unread→new・read→in_progress・replied→completed）
 */
export const FORM_SUBMISSION_LEGACY_STATUS_VALUES = ['unread', 'read', 'replied'] as const;
